
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform<T>(items: T[], searchText: string, keys?: readonly string[]): T[] {
        if (!items || !searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();

        const filterRecursive = (list: T[]): T[] => {
            return list
                .map((item: T): T | null => {
                    const matches = this.matches(item, searchText, keys);
                    const children = (item as { children?: T[] })?.children;
                    const filteredChildren = children ? filterRecursive(children) : [];

                    if (matches || filteredChildren.length > 0) {
                        return { ...item, children: filteredChildren };
                    }
                    return null;
                }).filter((x): x is T => x !== null);
        };

        return filterRecursive(items);
    }

    private matches<T>(item: T, searchText: string, keys?: readonly string[]): boolean {
        if (typeof item === 'string') {
            return item.toLowerCase().includes(searchText);
        }

        if (item && typeof item === 'object') {
            const searchKeys = keys && keys.length ? keys : ['name'];
            const record = item as Record<string, unknown>;
            return searchKeys.some(key =>
                String(record[key] ?? '').toLowerCase().includes(searchText)
            );
        }

        return false;
    }
}
